<template>
  <div class="dapp-box">
    <div class="w" id="dapp">
      <div class="title">
        <!-- DAPP应用 -->
        {{ $t("dapp.box2T") }}
      </div>
      <div class="gang"></div>
      <div class="subTitle">
        <!-- 一些polysmartchain.com团队现在喜欢的去中心化应用。下面是更多的去中心化应用。 -->
        {{ $t("dapp.box2ST") }}
      </div>
      <div class="box">
        <div class="wl-item2" v-for="(item, index) in list" :key="index">
          <div class="img">
            <img
              :src="`https://relayapp-store.polysmartchain.com/static/logo/${item.image}`"
              alt=""
            />
          </div>
          <div class="t">{{ item.name }}</div>
          <div class="link"></div>
          <div class="android">
            <span>WEB</span>
            <span>IOS</span>
            <span>Android</span>
          </div>
          <div class="p pfont">
            {{ item.description }}
          </div>
          <!-- <div class="more">
            <span
              class="copy hash"
              @click="doCopy()"
              :data-clipboard-text="store.link.home.box6List[index]"
              >{{ $t("dapp.copy") }}</span
            >
            <a
              href="javascript:;"
              @click="uti.goPath(store.link.home.box6List[index])"
            >
              {{ item.ft }}
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-arrowRight"></use>
              </svg>
            </a>
          </div> -->
          <div class="more">
            <a
              href="javascript:; "
              v-if="item.url"
              @click="uti.goPath(item.url)"
            >
              {{ item.url }}
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-arrowRight"></use>
              </svg>
            </a>
            <br />
            <span
              class="copy hash"
              v-if="item.address"
              @click="doCopy()"
              :data-clipboard-text="item.address"
            >
              <!-- {{ $t("dapp.copy") }} -->
              {{ item.address }}
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-copy"></use>
              </svg>
            </span>
          </div>
        </div>
        <div class="zw"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Store from "../../store";
import Clipboard from "clipboard";
import { getDappListApi } from "../../assets/api/api.js";
export default {
  data() {
    return {
      uti: Store.uti,
      store: Store.state,
      list: [
        {
          index: 1,
          type: "en,cn",
          image: "swap.png",
          name: "Swanswap",
          version: "1.0.7",
          address: "16GFVKFeCcweKQiS3MRQLc7o3YHhDgh8MT",
          description:
            "The liquidity hub of PolySmartChain, offering efficient matching and low-slippage trading experience.",
          official: true,
          url: "https://swanswap.polysmartchain.com/",
          platform:
            '[{name:"iOS",support:"true"},{name:"Androld",support:"true"},{name:"Web",support:"true"}]',
        },
        {
          index: 2,
          type: "en,cn",
          image: "farm.png",
          name: "Swanfarm",
          version: "1.0.9",
          address: "1BSuEF3L3No5aGoefKidaDQL6hKm2kBFhR",
          description:
            "As the yield aggregator of PolySmartChain, it helps users discover diversified DeFi earning opportunities and build a stable, sustainable source of passive income.",
          official: true,
          url: "https://pool.polysmartchain.com/",
          platform:
            '[{name:"iOS",support:"true"},{name:"Androld",support:"true"},{name:"Web",support:"true"}]',
        },
        {
          index: 3,
          type: "en,cn",
          image: "bridge.png",
          name: "Bridge",
          version: "1.0.0",
          address: "1EwcPzqsTq7YsWr48vWD1QPr6jHbn9WaTE",
          description:
            "The cross-chain bridge of PolySmartChain supports seamless migration of multi-chain assets—secure, convenient, and low-cost—building a truly interconnected cross-chain ecosystem.",
          official: true,
          url: "https://bridge.polysmartchain.com/",
          platform:
            '[{name:"iOS",support:"true"},{name:"Androld",support:"true"},{name:"Web",support:"true"}]',
        },
        {
          index: 5,
          type: "en,cn",
          image: "social.png",
          name: "Social",
          version: "3.6.4",
          address: "12mTgx1ju9mbdWEsjfMDDpvXfPUeGjmeVK",
          description:
            "PolySmartChain’s social mining pool integrates social interactions with incentive mechanisms. Users can mine by sharing—earn as you connect, igniting community engagement.",
          official: true,
          url: "https://social.polysmartchain.com/",
          platform:
            '[{name:"iOS",support:"true"},{name:"Androld",support:"true"},{name:"Web",support:"true"}]',
        },
        {
          index: 6,
          type: "en,cn",
          image: "polyjetclub.png",
          name: "PolyjetClub",
          version: "1.2.2",
          address: "1Dcscm4M48Uhfpfj7fvKa1u5KfxBKEYf5U",
          description:
            "Here, you can buy and trade pineapple avatars and potion bottles to unlock identity perks and advanced features. With one-click listings and instant transactions, build your own Polyjet digital collectibles economy.",
          official: true,
          url: "",
          platform: "",
        },
        {
          index: 7,
          type: "en,cn",
          image: "catpool_cn.png",
          name: "Catpool China",
          version: "2.1.1",
          address: "1La4wKoJoE1ABHTdSKVmKMWfBCjwhdvi4v",
          description:
            "The CAT Network mining pool tailored for Chinese-speaking communities offers deep integration with the CAT ecosystem—supporting node hosting, reward distribution, and technical guidance, enabling effortless decentralized mining.",
          official: true,
          url: "",
          platform: "",
        },
        {
          index: 8,
          type: "en",
          image: "catpool_global.png",
          name: "Catpool Global",
          version: "2.1.1",
          address: "1JjieJkL88E8jY2qECUc1FDfz2ZyCjCQd1",
          description:
            "Catpool Global is dedicated to providing sustained hashpower for the CAT network, building a global mining platform that is open to all, transparently rewarding, and highly efficient.",
          official: true,
          url: "",
          platform: "",
        },
        {
          index: 9,
          type: "en,cn",
          image: "protects.png",
          name: "Protect",
          version: "1.0.2",
          address: "1KDqy4WL9BTGm92xmWMnLUurdhPW8KotcA",
          description:
            "Enable with one click to prevent abnormal operations or asset theft. Multi-layer authentication and security strategies provide comprehensive protection for your on-chain assets.",
          official: true,
          url: "",
          platform: "",
        },
        {
          index: 10,
          type: "en,cn",
          image: "heartbeat.png",
          name: "Nodes heartbeat",
          version: "2.1.0",
          address: "1FiwtMPs8ywKUZtyWt4pXtf5tDrWw9ZZmX",
          description:
            "Continuously monitor the status of all nodes—offline status and latency are clear at a glance. You can also add your own nodes to track their performance and ensure uninterrupted rewards.",
          official: true,
          url: "",
          platform: "",
        },
        {
          index: 11,
          type: "en,cn",
          image: "bridge_air.png",
          name: "Bridge Air",
          version: "3.3.3",
          address: "14xVw3H6oPJvjf9YT57X9gaaSF8fRiKU8i",
          description:
            "Built on the CAT Network, the PolySmartChain cross-chain bridge enables secure, convenient, and low-cost transfers of assets across multiple chains—forming a truly interoperable ecosystem.",
          official: true,
          url: "",
          platform: "",
        },
      ],
    };
  },
  mounted() {
    this.getListFn();
  },
  methods: {
    doCopy() {
      // console.log(cp);
      var clipboard = new Clipboard(".hash");
      // console.log(clipboard);
      clipboard.on("success", () => {
        this.$message.success("success");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        // 不支持复制

        this.$message.error("error");
        // 释放内存
        clipboard.destroy();
      });
    },
    async getListFn(lang) {
      let { data: res } = await getDappListApi(lang);
      if (res.statusCode != 200) {
        return;
      }
      this.list = res.data;
    },
  },
};
</script>
<style lang="less" scoped>
.dapp-box {
  padding-top: 100px;
  padding-bottom: 250px;
  background-image: url("../../assets/images/v4/home/box2Bg.png"),
    url("../../assets/images/v4/home/box6Ft.png");
  background-repeat: no-repeat;
  background-position: 0 60%, right 100%;
  .title {
    font-size: 70px;
    font-weight: bold;
    color: #333333;
  }
  .gang {
    width: 60px;
    height: 7px;
    margin-top: 17px;
    background: linear-gradient(90deg, #015eea, #00c0fa);
  }
  .subTitle {
    height: 26px;
    font-size: 24px;
    font-weight: 500;
    color: #999999;
    margin-top: 38px;
  }
  .box {
    margin-top: 100px;
    // background-color: pink;
    width: 100%;
    // height: 500px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .wl-item2 {
      padding-bottom: 140px;
      margin-right: 20px;
      transition: 0.5s;
      // background: none;
      // background: linear-gradient(-45deg, #fff, #fff);
      .android {
        font-size: 14px;
        margin-top: 5px;
        font-weight: 400;
        color: #cccccc;
      }
      .link {
        margin-bottom: 0px;
      }
      .p {
        margin-top: 15px;
      }

      .more {
        .copy {
          margin-right: 20px;
          margin-top: 20px;
          display: block;
          opacity: 0.5;
        }
        cursor: pointer;
      }
    }
    .zw {
      width: 446px;
      flex: 1;
    }
    .wl-item2:hover {
      background: #015eea96;
      // background: linear-gradient(-45deg, #015eea, #00c0fa);
      color: #ffffff;
      position: relative;
      .t {
        color: #ffffff;
      }
      .link {
        background-color: #fff;
      }
      .android {
        color: #ffffff;
      }
      .p {
        color: #ffffff;
      }
      .more {
        color: #ffffff;
        a {
          color: #ffffff;
        }
      }
      .url {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
}
</style>
